/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'

import { APROVAR_MUT_DATA_INICIAL,
  APROVAR_MUT_DATA_FINAL,
  APROVAR_MUT_LOCALEXECUCAO,
  APROVAR_DIS_LISTAR } from './aprovar-const'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    dataInicial: null,
    dataFinal: null,
    localExecucao: null,
    resultado: [],
  },
  getters: {
    resultado() {
      return store.state.resultado
    },
  },
  mutations: {
    [APROVAR_MUT_DATA_INICIAL](state, payload) {
      state.dataInicial = payload
    },
    [APROVAR_MUT_DATA_FINAL](state, payload) {
      state.dataFinal = payload
    },
    [APROVAR_MUT_LOCALEXECUCAO](state, payload) {
      state.localExecucao = payload
    },
  },
  actions: {
    [APROVAR_DIS_LISTAR]() {
      const that = this
      if (that.state.dataInicial == null) return

      ApiLegacy.Provisao.listarAgrupadoParaAprovacao(that.state.localExecucao, that.state.dataInicial, that.state.dataFinal)
        .then((response) => {
          if (response.status === 200) {
            that.state.resultado = response.data.data
          } else {}
        })
    },
  },
})

export default store
